<template>
  <div
    class="context-menu"
    :style="{ left: position.x + 'px', top: position.y + 'px' }"
    @mouseleave="currentOpenSubMenu = null"
    @click.stop
    @contextmenu.stop
  >
    <div v-for="(item, index) in menuItems" :key="index">
      <div v-if="item.type === 'divider'" class="context-menu-divider"></div>
      <div
        v-else
        class="context-menu-item"
        :class="{ 'has-submenu': item.bindingFunction === 'container-btn' }"
        @click="handleItemClick(item)"
        @mouseover="handleMouseOver(item, $event)"
      >
        <span>
          {{ item.text }}
        </span>

        <span v-if="item.bindingFunction === 'container-btn'" class="menu-arrow">▶</span>

        <sub-menu
          v-if="item.bindingFunction === 'container-btn'"
          :menu-items="item.todoList"
          :parentRect="subMenuParentRect"
          @item-click="handleItemClick"
        ></sub-menu>
      </div>
    </div>
  </div>
</template>

<script>
import subMenu from './subMenu'

export default {
  // 组件名称
  name: 'contextMenu',
  // 组件参数 接收来自父组件的数据
  props: {
    menuItems: {
      type: Array,
      required: true,
      default: () => []
    },
    position: {
      type: Object,
      required: true,
      default: () => ({ x: 0, y: 0 })
    }
  },
  // 局部注册的组件
  components: {
    subMenu
  },
  mounted() {
    // 确保事件监听在 DOM 渲染完成后添加，并将组件挂载到 body
    document.body.appendChild(this.$el);
    setTimeout(() => {
      // 监听全局点击和右键事件，用于关闭菜单
      document.addEventListener('click', this.closeMenu);
      document.addEventListener('contextmenu', this.closeMenu);
    }, 0);
  },
  beforeUnmount() {
    // 移除事件监听和 DOM 元素
    document.removeEventListener('click', this.closeMenu);
    document.removeEventListener('contextmenu', this.closeMenu);
    if (document.body.contains(this.$el)) {
      document.body.removeChild(this.$el);
    }
  },
  // 组件状态值
  data() {
    return {
      subMenuParentRect: null, // 当前悬停项的 DOM 尺寸，用于子菜单定位
      currentOpenSubMenu: null, // 当前鼠标悬停的、有子菜单的菜单项
    }
  },
  methods: {
    handleItemClick(item) {
      if (item.bindingFunction !== 'container-btn') {
        // 如果不是容器按钮（子菜单），则触发操作并关闭菜单
        this.$emit('item-click', item);
        this.closeMenu();
      }
      // 如果是容器按钮，则不关闭，等待子菜单交互
    },
    /**
     * @description 鼠标悬停事件，用于获取子菜单的定位基准
     */
    handleMouseOver(item, event) {
      // 只有有子菜单的项才处理
      if (item.bindingFunction === 'container-btn') {
        this.currentOpenSubMenu = item;

        // 获取当前悬停菜单项的 DOM 尺寸，传递给 subMenu 组件计算位置
        this.subMenuParentRect = event.currentTarget.getBoundingClientRect();
      } else {
        // 悬停到一个没有子菜单的项时，关闭当前打开的子菜单
        this.currentOpenSubMenu = null;
      }
    },
    closeMenu() {
      this.$emit('close');
      this.currentOpenSubMenu = null; // 关闭时也清除子菜单状态
    },
  },
}
</script>

<style scoped lang="scss">
.context-menu {
  position: fixed;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  padding: 6px 0;
  z-index: 1000;
  font-size: 14px;
  // 保持动画效果，但它只影响主菜单的出现
  animation: fadeIn 0.15s ease-out;
  max-height: 350px;
}

.context-menu-item {
  padding: 8px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative; /* 核心：作为子菜单的定位基准 */
  transition: background-color 0.15s;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
}

.context-menu-item:hover {
  background-color: #F5F7FA; 
  color: #1942FF;
}

// 移除 has-submenu::after，使用 div 中的 span.menu-arrow
// .context-menu-item.has-submenu::after { ... } 

.menu-arrow {
    margin-left: 10px;
    font-size: 10px;
    color: #95a5a6;
}

.context-menu-divider {
  height: 1px;
  background-color: #ecf0f1;
  margin: 6px 0;
}

/* 彻底移除 submenu 相关的 CSS 定位和 hover 逻辑，完全交给 JS 控制 */
.submenu {
  position: absolute;
  /* 移除 left/top/opacity/visibility/transform/transition，由 JS 动态设置 */
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  padding: 6px 0;
  z-index: 1001;
}

/* 移除 .context-menu-item:hover > .submenu 样式 */

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>